import { render, staticRenderFns } from "./FundingIndex.vue?vue&type=template&id=ced4c866&"
import script from "./FundingIndex.vue?vue&type=script&lang=js&"
export * from "./FundingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports